import axios from "axios";

let apiInstance = null

export function initializeApi(getAccessTokenSilently) {
  if (apiInstance) return apiInstance

  apiInstance = createApi(getAccessTokenSilently)

  return apiInstance
}

export function getApi() {
  if (!apiInstance) {
    throw new Error("API not initialized")
  }

  return apiInstance
}

function createApi(getTokenFn) {
  const api = axios.create({
    timeout: 10000
  })

  api.interceptors.request.use(async (config) => {
    try {
      const token = await getTokenFn()
      if (token) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch (e) {
      console.warn('Token no disponible')
    }
    return config
  })

  return api
}
